var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "activity" }, [
    _c(
      "div",
      { staticClass: "activity-menu" },
      _vm._l(_vm.activetyList, function (item, i) {
        return _c("div", { key: i, staticClass: "menu-item" }, [
          _c(
            "div",
            {
              staticClass: "title",
              class: { active: _vm.curIndex === i },
              on: {
                click: function ($event) {
                  _vm.curIndex == i ? (_vm.curIndex = -1) : (_vm.curIndex = i)
                },
              },
            },
            [
              !_vm.$screen.mobile
                ? _c("i", {
                    staticClass: "ivu-icon",
                    class: [
                      {
                        "ivu-icon-ios-arrow-dropup": _vm.curIndex === i,
                      },
                      {
                        "ivu-icon-ios-arrow-dropdown": _vm.curIndex != i,
                      },
                    ],
                  })
                : _vm._e(),
              _vm._v(_vm._s(item.title) + " "),
              _vm.$screen.mobile
                ? _c("i", {
                    staticClass: "ivu-icon",
                    class: [
                      {
                        "ivu-icon-ios-arrow-up": _vm.curIndex === i,
                      },
                      {
                        "ivu-icon-ios-arrow-down": _vm.curIndex != i,
                      },
                    ],
                  })
                : _vm._e(),
            ]
          ),
          _c("div", {
            staticClass: "instructions",
            class: { show: _vm.curIndex == i },
            domProps: {
              innerHTML: _vm._s(
                _vm.activetyList[i].content.replace(
                  "/Upload/",
                  _vm.config.imgbaseURL + "/Upload/"
                )
              ),
            },
          }),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }